import { useRef, useCallback } from 'react';

export const MAX_TRANSCODE_RETRIES = 3;
export const MAX_HLS_RETRIES = 3;
export const MAX_TRANSCODE_REFETCH = 2;

const INITIAL_STATE = () => ({
  normalMode: { key: null, retried: false },
  hasTranscodeRetry: false,
  transcodeTimeout: false,
  retryTime: null,
  transcodeCount: 0,
  hlsCount: 0,
  refetchCount: 0,
});

export const useRetryManager = () => {
  const retryRef = useRef(INITIAL_STATE());

  const getErrorKey = useCallback((err, fallback) => {
    const readable = typeof err === 'string' ? err : err?.message || fallback;
    const code = err?.code || err?.status || err?.type || '';
    return `${String(code)}|${String(readable || fallback)}`
      .toLowerCase()
      .trim();
  }, []);

  const isSingleRetryNormalError = useCallback((errorKey = '') => {
    return /(404|stream not found|network error|hls\s*error|hlserror)/i.test(
      errorKey,
    );
  }, []);

  const resetNormalMode = useCallback(() => {
    retryRef.current.normalMode = { key: null, retried: false };
  }, []);

  const resetAll = useCallback(() => {
    retryRef.current = INITIAL_STATE();
  }, []);

  const resetTranscode = useCallback(() => {
    retryRef.current.transcodeCount = 0;
    retryRef.current.transcodeTimeout = false;
    retryRef.current.hasTranscodeRetry = false;
  }, []);

  return {
    retryRef,
    getErrorKey,
    isSingleRetryNormalError,
    resetNormalMode,
    resetAll,
    resetTranscode,
  };
};
